import * as React from 'react';
/**
 * Returns the action bar of the Dialog.
 * @returns React.ReactElement<any>
 */
export var DialogActionsBar = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "k-dialog-buttongroup k-dialog-button-layout-stretched" }, children));
};
//# sourceMappingURL=DialogActionsBar.js.map